import CreateTradeDialog from '@/components/trade/create/create-trade-in-appraisal-dialog';
import { Button } from '@/components/ui/button';
import { PDKAddIcon } from '@/components/ui/pdk-icons';
import { HOTKEYS } from '@/lib/hotkeys';
import type { Deal } from '@/models/registry';
import { useEffect, useRef, useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

const TradeCreateButton = ({
  dealId,
  // buttonClassName,
  dialogIsOpenProp = false,
  // setTradeInDialogIsOpen,
  // onSuccess,
  // onError,
}: {
  dealId?: Deal['id'];
  // buttonClassName?: string;
  dialogIsOpenProp?: boolean;
  // setTradeInDialogIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  // onSuccess?: (data: null, variables: { tradeIn: TradeIn }) => void;
  // onError?: (error: Error, variables: { tradeIn: TradeIn }) => void;
}) => {
  const [dialogIsOpen, setDialogIsOpen] = useState(dialogIsOpenProp);

  const buttonRef = useRef<HTMLButtonElement>(null);

  useHotkeys(HOTKEYS.TRADE_ADD, (e) => {
    e.preventDefault();
    e.stopPropagation();

    // TODO (jimmy): don't know why but this opens two dialogs
    buttonRef.current?.click();
  });

  // const queryClient = useQueryClient();
  // const createTradeInMutation = useMutation({
  //   // onMutate: async ({ tradeIn }) => {
  //   //   dealStore.addTradeIn({
  //   //     id: dealId,
  //   //     tradeIn: {
  //   //       ...tradeIn,
  //   //       deal_id: dealId,
  //   //     },
  //   //   });
  //   // },
  //   mutationFn: async ({ tradeIn }: { tradeIn: TradeIn }) => {
  //     const response = await pdkAxios
  //       .post(`/deals/${dealId}/trades/create`, { ...tradeIn })
  //       .catch((e) => {
  //         console.error('Error creating trade-in', e);
  //         throw e;
  //       });

  //     return response.data;
  //   },
  //   onSuccess: (data, variables) => {
  //     setDialogIsOpen(false);
  //     setTradeInDialogIsOpen?.(false);

  //     onSuccess?.(data, variables);
  //   },
  //   onError: (error, variables) => {
  //     onError?.(error, variables);

  //     console.error('Error creating trade-in', error, variables);
  //     // TODO (jimmy): toast an error
  //   },
  //   onSettled: () => {
  //     queryClient.invalidateQueries({ queryKey: ['deal', dealId] });
  //   },
  // });

  useEffect(() => {
    setDialogIsOpen(dialogIsOpenProp);
  }, [dialogIsOpenProp]);

  return (
    <div>
      <Button
        ref={buttonRef}
        variant="ghost"
        className="p-1 h-fit m-0"
        size="xs"
        onClick={() => {
          setDialogIsOpen(true);
        }}
      >
        <PDKAddIcon />
      </Button>
      <CreateTradeDialog
        open={dialogIsOpen}
        onOpenChange={setDialogIsOpen}
        initialDealId={dealId}
      />
    </div>
  );

  // return (
  //   <TradeInDialog
  //     initialVin={''}
  //     intialMake={''}
  //     initialModel={''}
  //     initialTrim={''}
  //     initialYear={''}
  //     initialMileage={''}
  //     initialPaidOff={false}
  //     initialLienholder={''}
  //     initialState={''}
  //     initialPostalCode={''}
  //     initialNumberOfKeys={0}
  //     initialAskingPrice={0}
  //     initialExteriorColor={''}
  //     initialInteriorColor={''}
  //     initialOffer={0}
  //     initialCondition={''}
  //     initialResellType={'none'}
  //     onClickCta={({
  //       vinValue,
  //       makeValue,
  //       modelValue,
  //       trimValue,
  //       yearValue,
  //       mileageValue,
  //       conditionValue,
  //       paidOffValue,
  //       lienholderValue,
  //       stateValue,
  //       postalCodeValue,
  //       numberOfKeysValue,
  //       askingPriceValue,
  //       exteriorColorValue,
  //       interiorColorValue,
  //       offerValue,
  //       resellTypeValue,
  //     }: {
  //       vinValue: string;
  //       makeValue: string;
  //       modelValue: string;
  //       trimValue: string;
  //       yearValue: string;
  //       mileageValue: string;
  //       conditionValue: string;
  //       paidOffValue: boolean;
  //       lienholderValue: string;
  //       stateValue: string;
  //       postalCodeValue: string;
  //       numberOfKeysValue: number;
  //       askingPriceValue: number;
  //       exteriorColorValue: string;
  //       interiorColorValue: string;
  //       offerValue: number;
  //       resellTypeValue: ResellType;
  //     }) => {
  //       createTradeInMutation.mutate({
  //         tradeIn: {
  //           id: uuidv4(),
  //           deal_id: dealId,
  //           vin: vinValue,
  //           make: makeValue,
  //           model: modelValue,
  //           trim: trimValue,
  //           year: parseInt(yearValue),
  //           mileage: parseInt(mileageValue),
  //           condition: conditionValue,
  //           paid_off: paidOffValue,
  //           lienholder: lienholderValue,
  //           state: stateValue,
  //           postal_code: postalCodeValue,
  //           number_of_keys: numberOfKeysValue,
  //           asking_price: askingPriceValue,
  //           exterior_color: exteriorColorValue,
  //           interior_color: interiorColorValue,
  //           offer: offerValue,
  //           resell_type: resellTypeValue,
  //         },
  //       });
  //     }}
  //     ctaText={'Add Trade-In'}
  //     onOpen={() => setDialogIsOpen(true)}
  //     onClose={() => {
  //       setDialogIsOpen(false);
  //       setTradeInDialogIsOpen?.(false);
  //     }}
  //     dialogIsOpen={dialogIsOpen}
  //   >
  //     <Button
  //       variant="ghost"
  //       className={cn('p-1 h-fit', buttonClassName)}
  //       ref={buttonRef}
  //       onClick={(e) => {
  //         e.preventDefault();
  //         e.stopPropagation();
  //         setDialogIsOpen(true);
  //       }}
  //     >
  //       <PDKAddTradeInIcon className={cn('h-3.5 w-3.5 cursor-pointer', {})} />
  //       <Tooltip>
  //         <TooltipTrigger asChild>
  //           <p className="rounded text-xs  text-gray-600">
  //             Add Trade-In
  //           </p>
  //         </TooltipTrigger>
  //         <TooltipContent className="flex flex-row gap-2 items-center">
  //           Add Trade-In
  //           <KeyboardKeyIcon>{HOTKEYS.TRADE_IN_ADD}</KeyboardKeyIcon>
  //         </TooltipContent>
  //       </Tooltip>
  //     </Button>
  //   </TradeInDialog>
  // );
};

export default TradeCreateButton;
